(() => {
  if (customElements.get('component-tabs')) {
    return;
  }

  class ComponentTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initElements();
      this.attachHandlers();
    }

    initElements() {
      this.select = this.querySelector('[data-select]');
      this.nav = this.querySelector('[data-nav]');
      this.tabsNavButtons = this.querySelectorAll('[data-tab-button]');
      this.tabs = this.querySelectorAll('[data-tab]');
    }

    attachHandlers() {
      this.nav.addEventListener('click', (event) => {
        if (event.target.hasAttribute('data-tab-button')) {
          this.handleTabButtonClick(event);
        }
      });

      this.select.addEventListener('change', (event) => {
        const targetButton = this.nav.querySelector(`[data-tab-button][href="${event.target.value}"]`);
        
        if (!targetButton) {
          return;
        }

        this.toggleTabButtonActive(targetButton);
        this.toggleTabs(targetButton);
      });
    }

    toggleTabButtonActive(button) {
      this.tabsNavButtons.forEach((tabsNavButton) => {
        tabsNavButton.classList.toggle('is-active', button === tabsNavButton);
      });
    }

    handleTabButtonClick(event) {
      event.preventDefault();

      this.toggleTabButtonActive(event.target);
      this.toggleTabs(event.target);
      this.updateSelect(event.target);
    }

    toggleTabs(button) {
      const targetTab = this.querySelector(button.getAttribute('href'));

      if (!targetTab) {
        return;
      }

      this.tabs.forEach((tab) =>
        tab.classList.toggle('is-active', tab === targetTab),
      );
    }

    updateSelect(button) {
      const targetOption = button.getAttribute('href');

      this.select.value = targetOption;
    }
  }

  customElements.define('component-tabs', ComponentTabs);
})();
